<template>
    <div>
        <v-container style="max-width:1000px;height:800px">
            {{store.state.ci0}}
            <h1 style="text-align:center">Bekräfta Ditt Schema</h1>
            <v-row>
                <v-col>
                    <p>Rubrik: {{ this.store.state.schedule.title }}</p>
                    <p>
                        Beskrivning: {{ this.store.state.schedule.description }}
                    </p>
                    <p>Plats: {{ this.store.state.schedule.location }}</p>

                    <v-simple-table :dense="true">
                        <thead>
                            <tr>
                                <th>Datum</th>
                                <th>Starttid</th>
                                <th>Sluttid</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="item in datesScheduled"
                                :key="item.date"
                            >
                                <td>{{ toDDMMYY(item.date) }}</td>
                                <td>{{ item.stime }}</td>
                                <td>{{ item.ftime }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col>
                    <div>
                        <p>
                            Username: {{ this.store.state.schedule.username }}
                        </p>
                        <p>
                            Endast Admin<v-icon
                                style="margin-left:10px;color:green"
                                v-if="store.state.schedule.adminOnly"
                                >fas fa-check</v-icon
                            ><v-icon style="margin-left:10px;color:red" v-else
                                >fas fa-times</v-icon
                            >
                        </p>
                        <p>
                            Enstaka svar:
                            <v-icon
                                style="margin-left:10px;color:green"
                                v-if="store.state.schedule.oneAns"
                                >fas fa-check</v-icon
                            ><v-icon style="margin-left:10px;color:red" v-else
                                >fas fa-times</v-icon
                            >
                        </p>
                        <p>
                            Kontaktinfo:
                            <v-icon
                                style="margin-left:10px;color:green"
                                v-if="store.state.schedule.contactInfo"
                                >fas fa-check</v-icon
                            ><v-icon style="margin-left:10px;color:red" v-else
                                >fas fa-times</v-icon
                            >
                        </p>
                    </div>
                </v-col>
                <v-col
                    ><p>
                        Dold schema:
                        <v-icon
                            style="margin-left:10px;color:green"
                            v-if="store.state.schedule.hidSchedule"
                            >fas fa-check</v-icon
                        ><v-icon style="margin-left:10px;color:red" v-else
                            >fas fa-times</v-icon
                        >
                    </p>
                    <p v-if="store.state.schedule.theme < 11">
                        Tema:
                        {{ themes[store.state.schedule.theme] }}
                    </p>
                    <p v-if="store.state.schedule.theme == 11">
                        Tema:
                        {{ store.state.schedule.customtheme }}
                    </p>
                    <p>
                        Deadline:
                        <v-icon
                            style="margin-left:10px;color:green"
                            v-if="store.state.schedule.deadlineReply"
                            >fas fa-check</v-icon
                        ><v-icon style="margin-left:10px;color:red" v-else
                            >fas fa-times</v-icon
                        >
                    </p>
                    <p v-show="store.state.schedule.deadlineReply">
                        Svarfrist:
                        {{ toDDMMYY(store.state.schedule.deadlineDate) }}
                    </p>
                </v-col>
            </v-row>
            <br />
            <v-btn style="background-color:#ffa500" @click="back"
                ><v-icon style="font-size:15px;margin-right:3px"
                    >fas fa-arrow-left</v-icon
                >Tillbaka</v-btn
            >
            <v-btn
                style="background-color:#ffa500;margin-left:3px"
                @click="submit"
                >Skicka in<v-icon style="font-size:15px;margin-left:3px"
                    >fas fa-check</v-icon
                ></v-btn
            >
        </v-container>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    data: () => ({
        store: store,
        datesScheduled: store.state.schedule.time,
        themes: [
            "Möte",
            "Övrigt",
            "Jobbmöte",
            "Svensexa",
            "Möhippa",
            "Middag",
            "Resa",
            "Fest",
            "Födelsedag",
            "Kalas",
            "Studentskiva",
            "Date"
        ]
    }),
    // created: function() {
    //     alert(this.store.state.schedule.time)
    //     this.datesScheduled = this.store.state.schedule.time

    // },
    methods: {
        back: function() {
            this.store.state.e1--;
        },
        submit: async function() {
            this.store.state.loading = true;
            let bodyFormData = new FormData();
            bodyFormData.append("user_id", this.store.state.user.id);
            bodyFormData.append(
                "time",
                JSON.stringify(this.store.state.schedule.time)
            );
            if (this.store.state.schedule.ifNeeded)
                bodyFormData.append("ifNeeded", "yes");
            else bodyFormData.append("ifNeeded", "no");
            if (this.store.state.schedule.deadlineReply) {
                bodyFormData.append("deadlineReply", "yes");
                bodyFormData.append(
                    "deadlineDate",
                    this.store.state.schedule.deadlineDate
                );
            } else bodyFormData.append("deadlineReply", "no");

            if (this.store.state.schedule.oneAns)
                bodyFormData.append("oneAns", "yes");
            else bodyFormData.append("oneAns", "no");
            if (this.store.state.schedule.hidSchedule)
                bodyFormData.append("hidSchedule", "yes");
            else bodyFormData.append("hidSchedule", "no");
            if (this.store.state.schedule.adminOnly)
                bodyFormData.append("adminOnly", "yes");
            else bodyFormData.append("adminOnly", "no");
            bodyFormData.append("title", this.store.state.schedule.title);
            if (this.store.state.schedule.contactInfo)
                bodyFormData.append("contactInfo", "yes");
            else bodyFormData.append("contactInfo", "no");
            bodyFormData.append(
                "description",
                this.store.state.schedule.description
            );
            bodyFormData.append("location", this.store.state.schedule.location);
            bodyFormData.append("theme", this.store.state.schedule.theme);
            bodyFormData.append("username", this.store.state.schedule.username);
            bodyFormData.append(
                "customtheme",
                this.store.state.schedule.customtheme
            );
            bodyFormData.append("ci0", this.store.state.ci0);
            bodyFormData.append("ci1", this.store.state.ci1);
            bodyFormData.append("ci2", this.store.state.ci2);
            bodyFormData.append("ci3", this.store.state.ci3);
            bodyFormData.append("ci4", this.store.state.ci4);
            var config = {
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await this.store.dispatch("createEvent", config);
            this.store.state.loading = false;
            this.$router.replace(`/schedule/${this.store.state.link}`);
        },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        }
    }
};
</script>

<style></style>
